export const ConvertMiladiDateToJalili = (miladiDay: string) => {
    let day = new Date(miladiDay).toLocaleDateString('fa-IR-u-nu-latn')
    return day
}
